import { useEffect, useState } from 'react';

/**
 * Returns a version of `value` that only updates after it has stopped changing
 * for `delayMs`. Used to keep the search input instant (immediate local state)
 * while the server query fires only once the user pauses — the SFDC mirror is
 * large, so we do NOT want a query per keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
